import React, { Component } from 'react'
import Line from '../Line'
import DecimalInput from '../../DecimalInput'

import { translation } from '../../../../utils/helpers'

// Elements
import Text from '../../../elements/text'

import './priceline.scss'

class PriceLine extends Component {
  constructor (props) {
    super(props)
    this.state = {
      taskName: '',
      type: null
    }
    this.changeValue = this.changeValue.bind(this)
    this.saveOrderPrice = this.saveOrderPrice.bind(this)
  }

  componentWillReceiveProps (newProps) {
    if (this.props.orderTaskPrice !== undefined) {
      this.setState({
        taskName: this.props.orderTaskPrice.TaskName,
        type: 'taskPrice'
      })
    } else if (this.state.type === null) {
      let type = null
      if (this.props.orderServiceTask !== undefined) {
        if (this.props.orderServiceTask.IsExtra) {
          type = 'extra'
        } else {
          type = 'service'
        }
      } else if (this.props.orderAddonPart !== undefined) {
        type = 'addonPart'
      } else if (this.props.orderAddonStartTime !== undefined) {
        type = 'addonStartTime'
      }
      this.setState({type: type})
    }
  }

  render () {
    if (this.props.orderTaskPrice !== undefined) return this.renderAsTaskPrice()
    if (this.props.orderServiceTask !== undefined) return this.renderAsServiceTask()
    if (this.props.orderAddonPart !== undefined) return this.renderAsAddonPart()
    if (this.props.orderAddonStartTime !== undefined) return this.renderAsAddonStartTime()

    return null
  }

  getItem () {
    if (this.props.orderTaskPrice !== undefined) return this.props.orderTaskPrice
    if (this.props.orderServiceTask !== undefined) return this.props.orderServiceTask
    if (this.props.orderAddonPart !== undefined) return this.props.orderAddonPart
    if (this.props.orderAddonStartTime !== undefined) return this.props.orderAddonStartTime
  }

  changeValue (args) {
    let item = this.getItem()
    if (item === null) return
    if (item[args.name] === args.value) return

    let orderPrice = this.props.orderPrice
    item[args.name] = args.value

    // Check if wanting to create new task
    if (args.name === 'TaskName' && args.value !== '' && this.props.orderTaskPrice !== undefined && item.PartItemId === 0 && item.OrderTaskId === 0) {
      orderPrice.Parts.push({
        Part: { PartItemId: 0 },
        Tasks: [item]
      })
      this.setState({taskName: item.TaskName})
    }
    this.saveOrderPrice(orderPrice)
  }

  saveOrderPrice (orderPrice) {
    let stripTasks = this.state.type !== 'taskPrice'
    let stripExtras = this.state.type !== 'extra'
    let stripServices = this.state.type !== 'service'

    this.props.saveOrderPrice(orderPrice, stripTasks, stripExtras, stripServices)
  }

  renderSubLine (propName, editable) {
    let item = this.getItem()
    let amount = item[propName]
    let text = propName
    switch (propName) {
      case 'AE':
        text = translation(885)
        break
      case 'Mat':
        text = translation(417)
        break
      case 'Discount':
        text = translation(15014)
        break
    }

    if (editable) {
      amount = () => {
        return (
          <div className='amount'>
            <DecimalInput size='s' className={propName.toLowerCase()} value={item[propName]} name={propName} onBlur={this.changeValue} />
          </div>
        )
      }
    }

    return <Line text={text} amount={amount} />
  }

  renderAsTaskPrice () {
    if (this.props.orderTaskPrice !== undefined && this.props.orderTaskPrice !== null && !this.props.orderTaskPrice.IsDeleted) {
      let item = this.props.orderTaskPrice
      let text = item.TaskName
      let amount = this.props.showAgreementPrice ? item.GrossWP : item.Gross
      if (this.props.showNet) {
        amount = this.props.showAgreementPrice ? item.NetWP : item.Net
      }

      /* if (this.props.isCustomer && item.PartItemId === 0 && amount === 0.0) {
        amount = ''
      } */

      let showPrices = ((this.props.order && this.props.order.ShowPrices) || this.props.editable) && !this.props.orderPrice.UseEstimation
      if (!showPrices) {
        amount = ''
      }

      if (this.props.noPrice) {
        amount = ''
      }

      let canEditTaskName = !this.props.orderPrice.HasAwaiting &&
        item.TaskPriceId === 0 &&
        this.props.department === 0 &&
        this.props.editable &&
        (!this.props.isCustomer || this.props.order.IsDraft)

      let canEditAmounts = !this.props.orderPrice.HasAwaiting &&
        item.OrderTaskId > 0 &&
        item.TaskPriceId === 0 &&
        this.props.department === 0 &&
        this.props.editable &&
        !this.props.isCustomer

      if (this.props.department === 0 && this.props.auth.departmentType === 1 && this.props.auth.hasPartner) {
        canEditAmounts = false
      }

      let subLines

      // Can edit text when no ordertaskid and part is 'other'
      if (canEditTaskName) {
        text = () => {
          return (
            <div className='text'>
              <Text
                size='s'
                value={this.state.taskName}
                onChange={(e) => this.setState({taskName: e.target.value})}
                onBlur={(e) => this.changeValue({name: 'TaskName', value: e.target.value})}
                />
            </div>
          )
        }
      }

      // Can edit ae, mat and discount when have ordertaskid and part is 'other'
      if (canEditAmounts) {
        subLines = []
        subLines.push(this.renderSubLine('AE', true))
        subLines.push(this.renderSubLine('Mat', true))
        subLines.push(this.renderSubLine('Discount', true))
      }
      let css
      if (canEditTaskName) {
        css = 'editable'
        if (item.OrderTaskId > 0) {
          css += ' small'
        }
      }

      return <Line
        // key={'line_' + this.props.key}
        className={css}
        text={text}
        amount={amount}
        canExpand={subLines !== undefined}
        onDelete={(this.props.editable && this.props.onDelete !== undefined) ? this.props.onDelete.bind(this, item) : undefined}
        subLine={!this.props.editable}
        >{subLines}</Line>
    }
    return null
  }

  renderAsServiceTask () {
    if (this.props.orderServiceTask !== undefined && this.props.orderServiceTask !== null && !this.props.orderServiceTask.IsDeleted) {
      let item = this.props.orderServiceTask
      let qty = ''
      if (item.Count > 1) {
        qty = ' (' + item.Count + ')'
      }
      let text = item.TaskName + qty
      let amount = item.Total
      if (this.props.showNet) {
        amount = item.Net
      }
      let showPrices = (this.props.order.ShowPrices || this.props.editable) && !this.props.orderPrice.UseEstimation
      // let showPrices = this.props.order.ShowPrices || this.props.editable
      if (!showPrices) {
        amount = ''
      }
      if (this.props.noPrice) {
        amount = ''
      }
      return <Line
        // key={this.props.key}
        text={text}
        amount={amount}
        boldText
        onDelete={(this.props.editable && this.props.onDelete !== undefined) ? this.props.onDelete.bind(this, item) : undefined}
        />
    }
    return null
  }

  renderAsAddonPart () {
    if (this.props.orderAddonPart !== undefined && this.props.orderAddonPart !== null && !this.props.orderAddonPart.IsDeleted) {
      let item = this.props.orderAddonPart
      let text = item.Name
      let amount = (this.props.isWp && this.props.showAgreementPrice) ? item.GrossWP : item.Price
      if (this.props.showNet) {
        amount = (this.props.isWp && this.props.showAgreementPrice) ? item.NetWP : item.Net
      }
      let showPrices = (this.props.order.ShowPrices || this.props.editable) && !this.props.orderPrice.UseEstimation
      // let showPrices = this.props.order.ShowPrices || this.props.editable
      if (!showPrices) {
        amount = ''
      }
      if (this.props.noPrice) {
        amount = ''
      }
      return <Line
        // key={this.props.key}
        text={text}
        amount={amount}
        boldText
        onDelete={this.props.onDelete !== undefined ? this.props.onDelete.bind(this, item) : undefined}
        />
    }
    return null
  }

  renderAsAddonStartTime () {
    if (this.props.orderAddonStartTime !== undefined && this.props.orderAddonStartTime !== null && !this.props.orderAddonStartTime.IsDeleted) {
      let item = this.props.orderAddonStartTime
      let text = item.Name
      let amount = (this.props.isWp && this.props.showAgreementPrice) ? item.GrossWP : item.Price
      if (this.props.showNet) {
        amount = (this.props.isWp && this.props.showAgreementPrice) ? item.NetWP : item.Net
      }
      let showPrices = (this.props.order.ShowPrices || this.props.editable) && !this.props.orderPrice.UseEstimation
      // let showPrices = this.props.order.ShowPrices || this.props.editable
      if (!showPrices) {
        amount = ''
      }
      if (this.props.noPrice) {
        amount = ''
      }
      return <Line
        // key={this.props.key}
        text={text}
        amount={amount}
        boldText
        onDelete={this.props.onDelete !== undefined ? this.props.onDelete.bind(this, item) : undefined}
        />
    }
    return null
  }
}

PriceLine.contextTypes = {
  router: React.PropTypes.object.isRequired
}

export default PriceLine



// WEBPACK FOOTER //
// ./src/app/shared/components/Extent/PriceLine/index.js